import { render, staticRenderFns } from "./SimpleText.vue?vue&type=template&id=bea50d36&"
import script from "./SimpleText.vue?vue&type=script&lang=ts&"
export * from "./SimpleText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports